import ReportContent from '@app/components/reports/components/report-content';
import { methodology } from './components/methodologies';
import { MethodologyRow } from './components/methodology-row';

export function Scope1MethodologyAppendix() {
  return (
    <ReportContent variant="appendix">
      {methodology.map((method, idx) => (
        <MethodologyRow key={idx} methodology={method} scope="scope1" />
      ))}
    </ReportContent>
  );
}
